// Utility for mapping list colors between light and dark themes
// Keeps a stable index so selecting a color in one theme maps to its counterpart in the other
export const LIST_COLOR_PALETTE = [
  { light: { bg: '#2D7D32', text: '#C8E6C9' }, dark: { bg: '#1A2E23', text: '#86EFAC' } }, // green
  { light: { bg: '#F57C00', text: '#FFE0B2' }, dark: { bg: '#3A2920', text: '#FDBA74' } }, // orange
  { light: { bg: '#D84315', text: '#FFCCBC' }, dark: { bg: '#2B1A1A', text: '#FF9B85' } }, // deep orange-red
  { light: { bg: '#7B1FA2', text: '#E1BEE7' }, dark: { bg: '#312244', text: '#C084FC' } }, // purple
  { light: { bg: '#1976D2', text: '#BBDEFB' }, dark: { bg: '#1C2431', text: '#60A5FA' } }, // blue
  { light: { bg: '#00796B', text: '#B2DFDB' }, dark: { bg: '#064E3B', text: '#5EEAD4' } }, // teal
  { light: { bg: '#689F38', text: '#DCEDC8' }, dark: { bg: '#33691E', text: '#A3E635' } }, // olive green
  { light: { bg: '#AD1457', text: '#F8BBD0' }, dark: { bg: '#880E4F', text: '#FB7185' } }, // pink
  { light: { bg: '#512DA8', text: '#D1C4E9' }, dark: { bg: '#2A2A40', text: '#A78BFA' } }, // indigo
  { light: { bg: '#009688', text: '#B2DFDB' }, dark: { bg: '#1E4044', text: '#67E8F9' } }, // aqua green
  { light: { bg: '#795548', text: '#D7CCC8' }, dark: { bg: '#3E2723', text: '#D6CCC2' } }, // brown
  { light: { bg: '#E65100', text: '#FFCC80' }, dark: { bg: '#3A241A', text: '#F97316' } }, // amber-orange
  { light: { bg: '#2196F3', text: '#BBDEFB' }, dark: { bg: '#0D47A1', text: '#93C5FD' } }, // bright blue
  { light: { bg: '#00BCD4', text: '#B2EBF2' }, dark: { bg: '#164E63', text: '#67E8F9' } }, // cyan
  { light: { bg: '#C62828', text: '#FFCDD2' }, dark: { bg: '#5C1A1A', text: '#FCA5A5' } }, // red
  { light: { bg: '#8E24AA', text: '#E1BEE7' }, dark: { bg: '#4A148C', text: '#E879F9' } }, // violet
  { light: { bg: '#4CAF50', text: '#C8E6C9' }, dark: { bg: '#1C2D24', text: '#86EFAC' } }, // soft green
  { light: { bg: '#FF5722', text: '#FFCCBC' }, dark: { bg: '#7C2D12', text: '#FB923C' } }, // vivid orange-red
  { light: { bg: '#3F51B5', text: '#C5CAE9' }, dark: { bg: '#1E1B4B', text: '#818CF8' } }, // deep blue-violet
  { light: { bg: '#9C27B0', text: '#E1BEE7' }, dark: { bg: '#3B0A45', text: '#D946EF' } }, // magenta
];


export const normalizeTheme = (theme) => {
  if (theme === 'dark' || theme === 'light') return theme;
  // For 'system', ThemeContext already sets data-theme on <html>
  const attr = (typeof document !== 'undefined')
    ? document.documentElement.getAttribute('data-theme')
    : 'light';
  return attr === 'dark' ? 'dark' : 'light';
};

export const getPaletteForTheme = (theme) => {
  const t = normalizeTheme(theme);
  // Include stable absolute index with each swatch so selection works even when colors repeat
  return LIST_COLOR_PALETTE.map((p, i) => ({ index: i, ...p[t] }));
};

export const findPaletteIndexByColor = (color) => {
  if (!color) return -1;
  const hex = color.toLowerCase();
  return LIST_COLOR_PALETTE.findIndex(p =>
    p.light.bg.toLowerCase() === hex || p.dark.bg.toLowerCase() === hex
  );
};

export const mapColorToTheme = (color, targetTheme) => {
  const idx = findPaletteIndexByColor(color);
  if (idx === -1) return null;
  const t = normalizeTheme(targetTheme);
  return LIST_COLOR_PALETTE[idx][t];
};

export const getCurrentThemeColor = (color, currentTheme) => {
  const idx = findPaletteIndexByColor(color);
  if (idx === -1) return { bg: color, text: null }; // Return original if not found
  const t = normalizeTheme(currentTheme);
  return LIST_COLOR_PALETTE[idx][t];
};
